import React from 'react';
import { Wrapper } from './styles';

const Loading = () => (
  <Wrapper>
    <div className="loader" />
  </Wrapper>
);

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading/index.js